import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampler: (samplingContext) => {
    if (samplingContext.transactionContext.name === "/404") {
      return 0.01;
    } else {
      return 0.1;
    }
  },
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
});
